/* eslint-disable @exodus/hydra/in-memory-atom-default-value */

import { createInMemoryAtom } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

import type { PlaygroundSbt } from '../types.js';

const playgroundSbtAtomDefinition = {
  id: 'playgroundSbtAtom',
  type: 'atom',
  factory: () => createInMemoryAtom<PlaygroundSbt | null>(),
  dependencies: [],
} as const satisfies Definition;

export default playgroundSbtAtomDefinition;
